import { render, staticRenderFns } from "./masterEvaluate.vue?vue&type=template&id=1b904e04&scoped=true&"
import script from "./masterEvaluate.vue?vue&type=script&lang=js&"
export * from "./masterEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./masterEvaluate.vue?vue&type=style&index=0&id=1b904e04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b904e04",
  null
  
)

export default component.exports